import React from 'react';
export const ModulesSection = () => {
  const modules = [{
    num: '1',
    icon: '🌳',
    title: 'Algoritmos y Estructuras de Datos',
    desc: 'De cero al árbol binario: Arrays, Listas, Pilas, Colas, Árboles, Grafos y los algoritmos de ordenamiento más pedidos en finales y entrevistas.'
  }, {
    num: '2',
    icon: '📐',
    title: 'Programación Orientada a Objetos',
    desc: 'Los 4 pilares explicados con código real. Diagramas UML, herencia, polimorfismo y diseño de clases desde cero hasta el nivel de examen.'
  }, {
    num: '3',
    icon: '🗄️',
    title: 'Base de Datos y SQL',
    desc: 'Del modelo relacional a las queries avanzadas. 50 consultas SQL resueltas por nivel de dificultad. JOINs, subconsultas y normalización sin misterios.'
  }, {
    num: '4',
    icon: '🤖',
    title: 'IA como tu Asistente de Programación',
    desc: 'Cómo usar ChatGPT y GitHub Copilot correctamente. 30 prompts listos para depurar código, preparar exámenes y simular entrevistas técnicas.'
  }, {
    num: '5',
    icon: '📚',
    title: 'Cómo Estudiar para Finales de Informática',
    desc: 'Las técnicas que funcionan para materias técnicas. Plan de 7 días, manejo del estrés, cómo recuperarse de un aplazo y el día del examen paso a paso.'
  }, {
    num: '6',
    icon: '💼',
    title: 'Tu Primer Trabajo en IT',
    desc: 'CV técnico, GitHub como portfolio, LinkedIn para ser encontrado, las 20 preguntas técnicas más pedidas y salarios reales en Argentina 2026.'
  }];
  const inclusions = ['20+ slides de contenido denso sin relleno', 'Código funcional listo para ejecutar', 'Ejercicios con soluciones paso a paso', 'Casos reales de estudiantes argentinos', 'Mapa conceptual visual de cierre', 'Checklist de dominio evaluable', 'Bibliografía académica actualizada 2026'];
  return <section className="bg-megapack-card py-10 md:py-16 px-4 md:px-6" data-id="element-141">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-142">
        <div className="text-center mb-10 md:mb-16" data-id="element-143">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-144">
            📚 LOS 6 MÓDULOS — Para aprobar <br className="hidden sm:block" data-id="element-145" />{' '}
            cualquier materia de Sistemas
          </h2>
          <p className="text-megapack-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-146">
            Cada módulo es un sistema completo con teoría, código funcional,
            ejercicios resueltos, casos reales y checklist de cierre.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-147">
          {modules.map((m, i) => <div key={i} className="bg-megapack-section border border-megapack-cyan/20 p-6 md:p-8 rounded-2xl card-hover" data-id="element-148">
              <div className="flex items-center justify-between mb-4 md:mb-6" data-id="element-149">
                <span className="text-megapack-cyan font-mono font-bold text-xs sm:text-sm" data-id="element-150">
                  MÓDULO {m.num}
                </span>
                <span className="text-3xl md:text-4xl" data-id="element-151">{m.icon}</span>
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4" data-id="element-152">
                {m.title}
              </h3>
              <p className="text-megapack-gray text-[14px] md:text-sm leading-relaxed" data-id="element-153">
                {m.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-megapack-bg border border-megapack-cyan/30 border-dashed p-6 md:p-12 rounded-3xl max-w-4xl mx-auto" data-id="element-154">
          <h4 className="text-lg md:text-xl font-bold mb-6 md:mb-8 text-center" data-id="element-155">
            Cada módulo incluye:
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-3 md:gap-y-4" data-id="element-156">
            {inclusions.map((item, i) => <div key={i} className="flex items-center gap-3 md:gap-4" data-id="element-157">
                <span className="text-megapack-green text-lg md:text-xl" data-id="element-158">
                  ✅
                </span>
                <span className="text-[14px] sm:text-base font-medium" data-id="element-159">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};